var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.287,41.224c0.184,0,0.368-0.051,0.53-0.152l24-15c0.292-0.183,0.47-0.503,0.47-0.848\n\ts-0.178-0.665-0.47-0.848l-24-15c-0.309-0.192-0.697-0.204-1.015-0.026c-0.318,0.176-0.515,0.511-0.515,0.875v30\n\tc0,0.363,0.197,0.698,0.515,0.875C11.954,41.182,12.12,41.224,12.287,41.224z M13.287,12.028L34.4,25.224L13.287,38.419V12.028z"}));
}

PlayInline.defaultProps = {"version":"1.1","width":"30px","height":"30px","x":"0px","y":"0px","viewBox":"0 0 50 50","enableBackground":"new 0 0 50 50","xmlSpace":"preserve"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
